import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {SadFaceIcon} from "../../../../../core/ui/SVGElements.jsx";
import {Messages} from "../../../../Messages";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";
import {Flow} from "../../../flows/Flow.js";
import {MessageElement} from "../../../../widget/ui/MessageElement.jsx";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";


export class PaymentFailedPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: "center",
        ...this.themeProps.MERCHANT_TITLE_STYLE,
    };

    @styleRule
    icon = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };

    @styleRule
    message = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(PaymentFailedPanelStyle)
export class PaymentFailedPanel extends BasePanelPage {
    formatPaymentErrorMessage(message) {
        let formattedMessage = (message || "").toString().trim();

        if (!formattedMessage.length) {
            return formattedMessage;
        }

        if (formattedMessage.slice(-1) !== ".") {
            formattedMessage += ".";
        }

        formattedMessage += " ";

        return formattedMessage;
    }

    render() {
        const {styleSheet, themeProps} = this;


        return [
            !iFrameMerchantService.isMerchant(TNR_ALIAS) &&
                <SadFaceIcon className={styleSheet.icon} size={72} color={themeProps.TEXT_SECONDARY_COLOR}/>,

            <div testId="subscribeFailedTitle" className={styleSheet.title}>
                {Messages.paymentFailed}
            </div>,

            <div testId="subscribeFailedMessage" className={styleSheet.message}>
                {iFrameMerchantService.isMerchant(TNR_ALIAS)
                    ? <MessageElement message={Messages.tnrContactCustomerSupport} />
                    : [this.formatPaymentErrorMessage(Flow.paymentMethod.getPaymentErrorMessage()), Messages.subscribeFailedMessage]}
            </div>,

            <BlinkButton
                label={Messages.editPaymentDetails}
                className={styleSheet.actionButton}
                onClick={() => Flow.back()}
            />,

            <LinkButton
                centered={true}
                label={Messages.retryPayment}
                onClick={() => {
                    // TODO @flow this is broken now
                    const retryPayment = Flow.paymentMethod.retryPayment || Flow.paymentMethod.onSelectSuccess;
                    retryPayment();
                }}
            />,
        ];
    }

    onMount() {
        super.onMount();

        this.attachListener(Flow.paymentMethod, () => this.redraw());
    }
}
